// Saves a favorite resort from the resort detail page

jQuery(function saveFavoriteResort($) {
	$('#js-favorite').each(function(index, el) {

		var $favoriteButton	= $(this);

		if (isFavoriteLoggedIn !== 'yes') {
			$favoriteButton.hide();
		} else {
			if (initFavoriteResort === 'yes') {
				// Initialize the Favorite Resort icon to its enabled state
				$favoriteButton.addClass('active');
			}

			$( $favoriteButton ).click(function() {
				if($favoriteButton.hasClass("active")){
					// Remove the favorite resort
					$.ajax({
						method: "POST",
						url: "/h/myaccount/RemoveFavoriteResorts",
						data: {
							resortid: $( "#js-resortid" ).html()
						}
					}).done (function(data) {
						if (data === "Success") {
							$favoriteButton.removeClass("active");
						} else {
							lDialog.open({
								content: '<div><h1 class="favorite-resort-help-header">An Error Occurred</h1><p class="favorite-resort-help-item">We&#39;re sorry, but an error occurred and we could not remove this resort from your favorites list.</p></div>'
							});
						}
					});
				} else {
					// Add this resort as a favorite
					$.ajax({
						method: "POST",
						url: "/h/myaccount/ManageFavoriteResorts",
						data: {
							resortid: $( "#js-resortid" ).html()
						}
					}).done (function(data) {
						if (data === "Success") {
							$favoriteButton.addClass("active");
								lDialog.open({
								content: '<div><h1 class="favorite-resort-help-header">Favorite Saved</h1><p class="favorite-resort-help-item">&quot;<span class="resort-name">' + $( "#js-resortname" ).html() + '</span>&quot; has been added to your list of <a href="/account/favorite-resorts">Favorite Resorts</a>.</p></div>'
							});
						} else {
							lDialog.open({
								content: '<div><h1 class="favorite-resort-help-header">Login Required</h1><p class="favorite-resort-help-item">You must be logged in to your account to save a resort to your favorites. Please <a href="/account/login">Login</a> or <a href="/account/register">Register</a> to save this resort to your favorites.</p></div>'
							});
						}
					});
				}
			});
		}
	});
});